
  import { Component, Vue ,Prop ,Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import * as echarts from 'echarts';
  @Component({  
    name: '',
    components: {
      PageFooter,
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:()=>{return []}}) data:any
    @Prop({default:()=>{return {value:'value',name:'name'}}}) option!:any
    @Prop() title!:any
    @Prop({default:()=>{return []}}) lines:any
    @Prop({default:undefined}) areaStyle!:any
    @Prop({default:1}) interval!:any
    @Prop({default:''}) yaxislabel!:any
    @Prop({default:false}) hasdefault!:any

    private key = Math.random()

    @Watch('data',{deep:true})
    private watchdata(val){
      // console.log(val)
      this.$nextTick(()=>{
        this.initcharts()
      })
    }

    private mounted () {
    // console.log(this.option) 
    // console.log(this.data)
      this.$nextTick(()=>{
        this.initcharts()
      })
    }
    private initcharts(){
      let chartDom = document.getElementById('charts'+this.key);
      let myChart = echarts.init(chartDom);
      let option:any = {
        // title: {
        //   text: this.title,
        //   subtext: 'Fake Data',
        //   left: 'center',
        // },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          top:'0%',
          left: 'center',
          data:this.lines.map(v=>{
            return v.name
          }),
          selected:{}
        },
        yAxis: {
          type: 'value',
          minInterval:1,
          // interval:this.interval,
          // min:(val)=>{
          //   return val.min
          // },
          // max:(val)=>{
          //   return val.max
          // },
          axisLabel:{
            formatter:'{value} ' + this.yaxislabel
          }
        },
        xAxis: {
          type: 'category',
          data: this.data.map(v=>v.Date.substring(0,10))
        },
        series: [],
      };
      // console.log(this.data)
      option.series = this.lines.map(v=>{
        // console.log(v)
        let val:any = {
          name:v.name,
          type:'line',
          data:[],
          areaStyle:this.areaStyle
        }
        val.data = this.data.map(x=>{
          return {
            value:x[v.key],
            name:v.key
          }
        })
        if(this.hasdefault){
          option.legend.selected[v.name] = v.defaultshow
        }
        // console.log(val.data)
        return val
      })
      // console.log(option.legend.selected)
      // console.log(option.series)
      // console.log(chartDom)
      option && myChart.setOption(option);
      this.$forceUpdate()
    }
  }
